import { PROJECT_SEARCH_PARAM_KEY } from "@repo/shared";

/**
 * Every search param a project tab may carry. Anything else is dropped when a location is
 * adopted into a tab (`routing/core/locations.ts`), so a key that is not here is a write that
 * silently never happens — a sort picked from a menu, a panel that never opens.
 *
 * The shared vocabulary is spread in whole rather than listed a second time: each of its keys
 * exists because some screen remembers it in the tab, so there is no shared key that should
 * *not* survive adoption, and a second hand-kept list only offered a place for the two to drift.
 * The literals after it are this app's own, unnamed keys.
 */
export const PROJECT_TAB_SEARCH_PARAM_KEYS = [
  ...Object.values(PROJECT_SEARCH_PARAM_KEY),
  "q",
  "vs",
  "crf",
  "crc",
  "crcf",
] as const;

export const ALLOWED_PROJECT_SEARCH_PARAMS = new Set<string>(PROJECT_TAB_SEARCH_PARAM_KEYS);
